import { User } from 'firebase/auth';

export enum Role {
  KLINIK = 'KLINIK',
  PETUGAS_KEGIATAN = 'PETUGAS_KEGIATAN',
  PENGGUNA = 'PENGGUNA'
}

export const KNOWN_EMAILS: Record<string, string> = {
};

export const AVAILABLE_MENUS = [

    // Portal Guru Specific Menus
    { id: 'portal-guru', label: 'Portal Guru (Akses Dasar)', category: 'Portal Guru' },
    { id: 'pg-menu-umum', label: 'Menu Umum', category: 'Portal Guru' },
    { id: 'pg-sarpras', label: 'Menu Sarpras', category: 'Portal Guru' },
    { id: 'pg-menu-presensi-kegiatan', label: 'Menu Presensi Kegiatan', category: 'Portal Guru' },
    { id: 'pg-kiosk-presensi', label: 'Kiosk Presensi Kegiatan', category: 'Portal Guru' },
    { id: 'pg-kelola-kegiatan', label: 'Kelola Kegiatan (Presensi Kegiatan)', category: 'Portal Guru' },
    { id: 'pg-bagian-kesehatan', label: 'Bagian Kesehatan', category: 'Portal Guru' },
    { id: 'pg-bagian-perizinan', label: 'Bagian Perizinan', category: 'Portal Guru' },
    { id: 'pg-bagian-resepsionis', label: 'Bagian Resepsionis', category: 'Portal Guru' },
    { id: 'pg-mudir', label: 'Mudir', category: 'Portal Guru' },
    { id: 'pg-akademik', label: 'Akademik', category: 'Portal Guru' },
    { id: 'pg-waka-kurikulum', label: 'Waka Kurikulum', category: 'Portal Guru' },
    { id: 'pg-tahfidz', label: 'Menu Tahfidz', category: 'Portal Guru' },
    { id: 'pg-koordinator-tahfidz', label: 'Koordinator Tahfidz', category: 'Portal Guru' },
    { id: 'pg-murobbi', label: 'Murobbi', category: 'Portal Guru' },
    { id: 'pg-wali-kelas', label: 'Wali Kelas', category: 'Portal Guru' },
    { id: 'pg-kepala-divisi', label: 'Kepala Divisi', category: 'Portal Guru' },
    { id: 'pg-waka-kesiswaan', label: 'Waka Kesiswaan', category: 'Portal Guru' },
    { id: 'pg-departemen-pendidikan', label: 'Departemen Pendidikan', category: 'Portal Guru' },
    { id: 'pg-kesantrian', label: 'Kesantrian', category: 'Portal Guru' },
    { id: 'pg-kepala-sekolah', label: 'Kepala Sekolah', category: 'Portal Guru' },
    { id: 'pg-prestasi', label: 'Data Prestasi', category: 'Portal Guru' },
    { id: 'pg-keuangan', label: 'Keuangan', category: 'Portal Guru' },
    { id: 'pg-takmir', label: 'Takmir', category: 'Portal Guru' },
    { id: 'pg-staf-tarbiyah', label: 'Staf Tarbiyah', category: 'Portal Guru' },
    { id: 'pg-staf-lughoh', label: 'Staf Lughoh', category: 'Portal Guru' },
    { id: 'pg-staf-penjadwalan', label: 'Staf Penjadwalan', category: 'Portal Guru' },
    { id: 'pg-ekskul', label: 'Ekstrakurikuler', category: 'Portal Guru' },
    { id: 'pg-tata-usaha', label: 'Tenaga Administrasi Umum', category: 'Portal Guru' },
    { id: 'pg-sekretariat', label: 'Sekretariat', category: 'Portal Guru' },
    { id: 'pg-peralatan', label: 'Peralatan', category: 'Portal Guru' },
    { id: 'pg-qurban', label: 'Qurban Idul Adha', category: 'Portal Guru' },
    { id: 'pg-mias-media', label: 'MIAS Media', category: 'Portal Guru' },
    { id: 'pg-kegiatan-suma', label: 'Kegiatan Subuh dan Maghrib', category: 'Portal Guru' },
    { id: 'pg-kurikulum-suma', label: 'Kurikulum Subuh dan Maghrib', category: 'Portal Guru' },
];


export type AdminTab =
  | 'santri'
  | 'perizinan'
  | 'petugas'
  | 'blacklist'
  | 'laporan'
  | 'whatsapp'
  | 'kelola-absen'
  | 'kelola-liburan'
  | 'klinik'
  | 'kegiatan-santri'
  | 'kelas'
  | 'asrama'
  | 'murobbi'
  | 'tahun-ajaran'
  | 'pengguna';

export enum PermitStatus {
  PENDING_CHECKOUT = 'Menunggu Checkout',
  OUT = 'Sedang Keluar',
  COMPLETED = 'Selesai',
  CANCELED = 'Dibatalkan',
  COMPLETED_BY_SYSTEM = 'Tidak Laporan'
}

export enum PermitType {
  KELUAR = 'Izin Keluar',
  PULANG = 'Izin Pulang',
  IZIN_TERBIMBING = 'Izin Terbimbing',
  IZIN_JOGGING = 'Izin Jogging'
}

export interface Santri {
  id: string;
  rfid: string;
  nis?: string;
  nip?: string;
  tahunMasuk?: number | string;
  nama: string;
  kelas: string;
  asrama: string;
  murobbi: string;
  waliKelas: string;
  noHp?: string;
  jenisKelamin?: 'Laki-laki' | 'Perempuan';
  status: 'Aktif' | 'Nonaktif' | 'Alumni' | 'Alumni PAUD' | 'Alumni SD' | 'Alumni SMP' | 'Alumni SMA';

  // Detail Data
  tempatLahir?: string;
  tanggalLahir?: string; // YYYY-MM-DD
  nisn?: string;
  nik?: string;
  noKk?: string;
  noAkte?: string;
  foto?: string; // URL

  // Detail Personal
  citaCita?: string;
  hobby?: string;
  golonganDarah?: 'A' | 'B' | 'AB' | 'O' | '-';
  tinggiBadan?: number; // cm
  beratBadan?: number; // kg
  ukuranBaju?: string;
  ukuranSepatu?: number;
  anakKe?: number;
  jumlahSaudara?: number;

  // Riwayat Sekolah
  asalSekolahSD?: string;
  noIjazahSD?: string;
  asalSekolahSMP?: string;
  noIjazahSMP?: string;
  statusSekolah?: 'Internal' | 'Eksternal';

  // Data Ayah
  namaAyah?: string;
  tanggalLahirAyah?: string; // YYYY-MM-DD
  pendidikanAyah?: string;
  pekerjaanAyah?: string;
  isPegawaiMiasAyah?: boolean;
  statusAyah?: 'Hafidzahullah' | 'Rahimahullah';

  // Data Ibu
  namaIbu?: string;
  tanggalLahirIbu?: string; // YYYY-MM-DD
  pendidikanIbu?: string;
  pekerjaanIbu?: string;
  isPegawaiMiasIbu?: boolean;
  statusIbu?: 'Hafidzahallah' | 'Rahimahallah';
  statusOrangTua?: 'Lengkap' | 'Yatim Piatu' | 'Yatim' | 'Piatu';
  statusCivitas?: 'Civitas' | 'Non Civitas';

  // Alamat
  alamatJalan?: string;
  rt?: string;
  rw?: string;
  desaKelurahan?: string;
  kecamatan?: string;
  kabupatenKota?: string;
  provinsi?: string;
  kodePos?: string;
  kewarganegaraan?: 'WNI' | 'WNA';
  statusPerkawinan?: 'Belum Kawin' | 'Kawin' | 'Cerai Hidup' | 'Cerai Mati';
  email?: string;

  // Administrative Codes for Satu Sehat
  kodeProvinsi?: string;
  kodeKabupaten?: string;
  kodeKecamatan?: string;
  kodeDesaKelurahan?: string;
}


export interface Permit {
  id: string;
  checkoutId: string;
  checkinId: string | null;
  
  santri: Santri[]; // Changed to array to support multiple santri

  alasan: string;
  tujuan: string;
  plannedDepartureTime: Date;
  rencanaKembali: Date;
  status: PermitStatus;
  permitType: PermitType;
  creationTime: Date;
  checkoutTime: Date | null;
  checkinTime: Date | null;
  
  pembimbing?: string; // For Izin Terbimbing
  noWali?: string; // For Izin Pulang
  keteranganTelat?: 'Tepat Waktu' | 'Terlambat' | 'Dibatalkan';
  durasiTelat?: string;
  alasanTelat?: string;
  petugasIzin: string;
  petugasCheckout: string | null;
  petugasCheckin: string | null;

  // Clinic Integration
  isClinicPermit?: boolean;
  doctorRecommendation?: string;
  relatedKlinikId?: string;
  izinDarurat?: boolean;

  // Activity Appreciation Integration
  relatedKegiatanId?: string;
}

export type NewPermitData = Pick<Permit, 'alasan' | 'tujuan' | 'plannedDepartureTime' | 'rencanaKembali' | 'permitType' | 'noWali' | 'pembimbing'> & {
  santriIds: string[];
  isClinicPermit?: boolean;
  doctorRecommendation?: string;
  relatedKegiatanId?: string;
  relatedKlinikId?: string;
  izinDarurat?: boolean;
  customCheckinId?: string; // Optional custom ID for Clinic flow
};
export type NewSantriData = Omit<Santri, 'id'>;

export interface BlacklistEntry {
    id: string;
    santriId: string;
    santriName: string;
    startDate: Date;
    endDate: Date;
    reason: string;
}

export type NewBlacklistData = Omit<BlacklistEntry, 'id'>;

export interface AbsensiLiburan {
  id: string;
  nama: string;
  jenis: 'Liburan' | 'Kedatangan';
  tanggal: Date;
  jamAkhir?: string; // HH:mm format
  toleransiTerlambat?: number; // in minutes
  isActive: boolean;
}

export type NewAbsensiLiburanData = Omit<AbsensiLiburan, 'id'>;

export interface AbsenRecord {
  id: string;
  santriId: string;
  santriName: string;
  kelas: string;
  asrama: string;
  absensiId: string;
  absensiName: string;
  jenisAbsen: 'Liburan' | 'Kedatangan';
  tanggalAbsen: Date;
  jamAbsen: string; // HH:mm
  petugasName: string;
  Status?: string;
  keterangan?: string;
  durasiTelat?: string;
}

export type NewAbsenRecordData = Omit<AbsenRecord, 'id'>;

export interface SyaratLiburan {
  id: string;
  namaSyarat: string;
  lokasi: 'Putra' | 'Putri';
  status: 'Aktif' | 'Non Aktif';
}

export type NewSyaratLiburanData = Omit<SyaratLiburan, 'id'>;

export type WhatsappLogStatus = 'sent' | 'failed' | 'pending';

export interface WhatsappLog {
  id: string;
  permitId: string;
  santriName: string; // Nama santri utama atau pembimbing
  recipient: string; // Nomor HP atau Nama Grup
  message: string;
  status: WhatsappLogStatus;
  timestamp: Date;
  error?: string;
}

export interface PermitContextType {
  loading: boolean;
  permits: Permit[];
  blacklist: BlacklistEntry[];
  whatsappLogs: WhatsappLog[];
  uniquePembimbing: string[];
  addPermit: (newPermitData: NewPermitData) => Promise<Permit | null>;
  checkoutPermit: (checkoutId: string) => Promise<Permit | undefined>;
  checkoutPermitByDocId: (docId: string) => Promise<Permit | undefined>;
  checkinPermit: (checkinId: string, reason?: string) => Promise<Permit | undefined>;
  updatePermit: (id: string, data: Partial<Permit>) => Promise<void>;
  deletePermits: (permitIds: string[]) => Promise<void>;
  getPermitsBySantriId: (santriId: string, month?: number, year?: number, yearString?: string) => Promise<Permit[]>;
  getSantriPermitHistory: (santriId: string) => Promise<Permit[]>;

  // Blacklist Management
  addBlacklistEntry: (data: NewBlacklistData) => Promise<void>;
  updateBlacklistEntry: (id: string, data: Partial<NewBlacklistData>) => Promise<void>;
  deleteBlacklistEntry: (id: string) => Promise<void>;

  // Permit Management
  cancelPermit: (permitId: string) => Promise<void>;
  extendPermitTime: (permitId: string, newReturnDate: Date) => Promise<void>;
  forceCheckin: (permitId: string, actualCheckinTime: Date) => Promise<void>;
  backfillPermitData: () => Promise<number>;

  // Checkout settings
  earlyCheckoutHours: number;
  updateEarlyCheckoutHours: (hours: number) => Promise<void>;

  // Scanner settings
  scannerWithForm: boolean;
  updateScannerWithForm: (value: boolean) => Promise<void>;

  // WhatsApp Log Management
  resendWhatsappMessage: (log: WhatsappLog) => Promise<void>;
  deleteWhatsappLogs: (logIds: string[]) => Promise<void>;

  // On-demand search (beyond 20-day subscription window)
  searchPermits: (keyword: string, maxResults?: number) => Promise<Permit[]>;
}

export type KegiatanAbsenStatus = 'Hadir' | 'Sakit' | 'Izin' | 'Alpha';

export interface KegiatanAbsen {
  id: string;
  kegiatanId: string;
  namaKegiatan: string;
  studentId: string;
  studentName: string;
  kelas: string;
  status: KegiatanAbsenStatus;
  tanggal: Date;
  petugas: string;
  tahunAjaran?: string;
  semester?: string;
  // Parenting fields
  isParenting?: boolean;
  tamu?: 'Ikhwan' | 'Akhwat';
  label?: 'Ayah' | 'Ibu';
}

export interface KegiatanSesi {
  id: string;
  kegiatanId: string;
  tanggalWib: string; // 'YYYY-MM-DD'
  unitTipe: 'kelas' | 'asrama';
  unit: string;
  status: 'ditutup' | 'tidak_dipresensi';
  jumlahAlpha: number;
  jumlahIzin: number;
  ditutupOleh: string;
  ditutupPada: Date;
}

export interface Kegiatan {
  id: string;
  namaKegiatan: string;
  lokasi: ('Putra' | 'Putri')[];
  jenjang: ('SMP' | 'SMA')[];
  jenis: 'Rutin' | 'Non Rutin';
  isActive: boolean;
  isParenting?: boolean;
  /** Lihat utils/metodeAbsensi.ts: satu metode, gabungan 'A + B', atau 'Hybrid'. */
  metodeAbsensi?: string;
  /** Id `tempat_presensi` tempat kegiatan berlangsung. Kosong = tidak tampil di kiosk. */
  tempat?: string[];
  // Rutin fields
  hari?: string[]; // e.g., ['Senin', 'Rabu']
  // Non Rutin fields
  tanggalMulai?: Date;
  tanggalAkhir?: Date;
  // Common time fields
  jamMulai: string; // HH:mm
  jamAkhir: string; // HH:mm
  toleransiTerlambat?: number; // in minutes
  absenBisaDimulaiSebelum?: number; // in minutes
  absenDitutupSetelah?: number; // in minutes
  targetPeserta?: 'Semua' | 'Kelas Tertentu';
  kelasPeserta?: string[];
  exceptions?: {
    santriIds: { id: string; reason: string; mode?: 'Izin' | 'BukanPeserta' }[];
  };

  // Apresiasi Izin Santri
  isApresiasiIzin?: boolean;
  apresiasiJenisIzin?: 'Izin Keluar' | 'Izin Pulang';
  apresiasiTanggalMulai?: Date;
  apresiasiJamMulai?: string;
  apresiasiTanggalSelesai?: Date;
  apresiasiJamSelesai?: string;
  apresiasiAlasan?: string;
  apresiasiTujuan?: string;
  apresiasiSkipReview?: boolean;
}

export type NewKegiatanData = Omit<Kegiatan, 'id'>;

/** Tempat yang dipasangi layar Kiosk Presensi (tabel `tempat_presensi`). */
export interface TempatPresensi {
  id: string;
  nama: string;
  gender: 'Putra' | 'Putri' | 'Campur';
  aktif: boolean;
  /** Tema tampilan layar kiosk di tempat ini. */
  tema: 'modern' | 'papan' | 'fokus';
}

/** Foto slideshow latar kiosk saat standby (tabel `kiosk_foto`). */
export interface KioskFoto {
  id: string;
  tempatId: string;
  path: string;
  url: string;
  urutan: number;
}

export interface KelasRecord {
  id: string;
  namaKelas: string;
  lokasi: 'Putra' | 'Putri';
  jenjang: 'SMP' | 'SMA';
  waliKelas: string;
  noHpWaliKelas?: string;
}
export type NewKelasData = Omit<KelasRecord, 'id'>;

export interface AsramaRecord {
  id: string;
  namaAsrama: string;
  lokasi: 'Putra' | 'Putri';
  murobbi?: string;
  status: 'Aktif' | 'Non Aktif';
}
export type NewAsramaData = Omit<AsramaRecord, 'id'>;

export enum KlinikStatus {
  DIPERIKSA = 'Cek Kesehatan',
  RAWAT_JALAN = 'Sakit (Rawat Jalan)',
  RAWAT_INAP = 'Sakit (Rawat Inap)',
  SEMBUH = 'Sembuh',
  RUJUK = 'Rujuk'
}

export interface KlinikCatatan {
  id: string;
  tanggal: Date;
  jam: string;
  petugas: string;
  suhu?: number;
  tensi?: string;
  keluhan?: string;
  tindakan?: string;
  obat?: string;
  catatan?: string;
}

export interface KlinikRecord {
  id: string;
  santriId: string;
  santriName: string;
  nis?: string;
  kelas: string;
  asrama: string;
  waliKelas: string;
  murobbi: string;
  lokasi?: string;

  // Pemeriksaan Fisik
  golonganDarah?: string;
  tinggiBadan?: number; // cm
  beratBadan?: number; // kg
  umur?: number;
  tensiDarah?: string;
  suhuBadan?: number;

  // New Vital Signs for Satu Sehat
  respRate?: number; // per minute
  heartRate?: number; // per minute
  oxygenSaturation?: number; // %

  // Detail Keluhan
  tanggalMasuk: Date;
  jamMasuk: string; // HH:mm
  keluhan: string;
  diagnosaAwal: string;
  diagnosisCode?: string; // ICD-10 Code (e.g., "A01.0")
  obatDiberikan: string;
  medicationCodes?: string[]; // Array of KFA Codes
  tindakan: string;
  status: KlinikStatus;
  petugasKlinik: string;

  // Satu Sehat Integration Fields
  encounterId?: string; // UUID from Satu Sehat
  patientId?: string; // HIS ID from Satu Sehat (likely linked to Santri but kept here for record integrity)
  practitionerId?: string; // NIK or IHS ID
  practitionerName?: string; // Name for display
  organizationId?: string; // Fasyankes ID
  locationId?: string; // Location ID
  startPeriod?: string; // ISO String
  endPeriod?: string; // ISO String

  // Condition/Diagnosis Details
  diagnosisType?: 'Primary' | 'Secondary'; // Default Primary
  conditionClinicalStatus?: 'active' | 'recurrence' | 'relapse' | 'inactive' | 'remission' | 'resolved';
  conditionVerificationStatus?: 'unconfirmed' | 'provisional' | 'differential' | 'confirmed' | 'refuted' | 'entered-in-error';
  conditionCategory?: 'problem-list-item' | 'encounter-diagnosis';
  conditionSeverity?: 'severe' | 'moderate' | 'mild';

  // Backend Compliance Fields
  nik?: string;
  jenisKelamin?: 'Laki-laki' | 'Perempuan';
  agama?: string;
  tempatLahir?: string;
  tanggalLahir?: string;
  kewarganegaraan?: string;

  // Link to Permit
  permitId?: string;

  // Fields Kondisional
  lokasiRawat?: 'Ikhwan' | 'Akhwat';
  ranjangKamar?: string;
  tanggalSembuh?: Date;
  jamSembuh?: string; // HH:mm
  tanggalRujuk?: Date;
  jamRujuk?: string; // HH:mm
  keteranganRujukan?: string;
  keteranganLainnya?: string;

  // Progress Notes
  catatanPerkembangan?: KlinikCatatan[];
}

export type NewKlinikRecordData = Omit<KlinikRecord, 'id'>;

export type UkuranBaju = 'S' | 'M' | 'L' | 'XL' | 'XXL' | 'XXXL';
export type GolonganDarah = 'A' | 'B' | 'AB' | 'O' | '-';

export interface GuruRecord {
  id: string;
  nama: string;
  niy: string;
  rfid: string;
  nik: string; // "Harus Angka" validation on UI, stored as string typically best for NIK
  noKk?: string;
  foto?: string; // URL
  tempatLahir: string;
  tanggalLahir: Date;
  // Umur is derived, typically not stored, but can be if requested. We'll derive it on UI.
  jenisKelamin: 'Laki-laki' | 'Perempuan';
  pendidikanTerakhir?: string;

  // Step 3: Kepegawaian
  divisi?: string;
  tanggalBergabung?: Date;
  isPengajar?: boolean;
  statusKeaktifan?: 'Aktif' | 'Nonaktif' | 'Cuti';
  groupPresensiId?: string;

  // Family Integration
  linkedFamilyIds?: string[]; // Deprecated, kept for migration safety if needed, or remove if fresh.
  familyConnections?: { targetId: string; role: string }[];
  statusKeluarga?: 'Kepala Keluarga' | 'Suami' | 'Istri' | 'Anak' | 'Menantu' | 'Cucu' | 'Orang Tua' | 'Mertua' | 'Famili Lain';

  // Step 4: Data Fisik & Atribut (Active again)
  golonganDarah?: GolonganDarah;
  tinggiBadan?: number;
  beratBadan?: number;
  ukuranBaju?: UkuranBaju;
  ukuranSepatu?: number;

  // Riwayat Pendidikan
  riwayatPendidikan?: Array<{
    jenjang: string;
    lembaga: string;
    tahunLulus?: string;
    jurusan?: string;
    fakultas?: string;
  }>;

  // Step 5: Kontak & Komunikasi
  noHp?: string;
  email?: string;

  // Step 6: Alamat Domisili
  alamatJalan?: string;
  rt?: string;
  rw?: string;
  desaKelurahan?: string;
  kecamatan?: string;
  kabupatenKota?: string;
  provinsi?: string;
  kodePos?: string;

  /**
   * true: pegawai baru yang disetujui cepat dari antrean pendaftar; semua menu terkunci
   * sampai ia melengkapi data diri sendiri (docs/PANDUAN_PERSETUJUAN_GURU_BARU.md).
   */
  perluLengkapiData?: boolean;
}

export type NewGuruData = Omit<GuruRecord, 'id'>;

export interface MurobbiRecord {
  id: string;
  nama: string;
  noHp?: string;
  lokasi: 'Putra' | 'Putri';
  status: 'Aktif' | 'Non Aktif';
  asramaBinaan: string[]; // List of asrama names
  isMudabbir: boolean;
}

export type NewMurobbiData = Omit<MurobbiRecord, 'id'>;

export interface TahunAjaranRecord {
  id: string;
  nama: string; // e.g. "2023/2024"
  tanggalMulai: Date;
  tanggalAkhir: Date;
  status: 'Aktif' | 'Non Aktif';
}

export type NewTahunAjaranData = Omit<TahunAjaranRecord, 'id'>;

export interface UserPermission {
  id: string;
  email: string;
  allowedMenus: string[];
  role?: string;
  /**
   * 'layanan' = akun login tanpa data pegawai (kiosk, meja perizinan, akun bersama).
   * Tidak terhitung sebagai pegawai. Kosong = akun pegawai.
   * Lihat docs/PANDUAN_AKUN_LAYANAN.md.
   */
  jenisAkun?: 'pegawai' | 'layanan';
  /** Nama tampil akun layanan, mis. "Kiosk Masjid Putra". */
  namaAkun?: string;
  keterangan?: string;
  /** false = akun layanan dinonaktifkan. Kosong = aktif. */
  aktif?: boolean;
  dibuatOleh?: string;
  dibuatPada?: string;
  diubahOleh?: string;
  diubahPada?: string;
  /** Menu yang dikosongkan otomatis karena pegawai Nonaktif (docs/PANDUAN_AKSES_PEGAWAI_NONAKTIF.md). */
  allowedMenusArsip?: string[];
  arsipAkses?: { pada: string; oleh: string; alasan: string; jumlahMenu: number } | null;
}

export const isAkunLayanan = (p?: Pick<UserPermission, 'jenisAkun'> | null): boolean => p?.jenisAkun === 'layanan';

export type NewUserPermissionData = Omit<UserPermission, 'id'>;

export interface Division {
  id: string;
  name: string;
  location: string;
  status: 'Aktif' | 'Non-Aktif';
  isJenjang?: boolean;
  kodeJenjang?: number;
}
export type NewDivisionData = Omit<Division, 'id'>;

export interface Position {
  id: string;
  name: string;
  description: string;
  level?: number;
}
export type NewPositionData = Omit<Position, 'id'>;

export interface KlinikLocationMap {
  internalName: string; // e.g., "Klinik Ikhwan", "Klinik Akhwat", "IGD"
  satusehatId: string;  // e.g., "L-001", "L-002"
}

export interface KlinikConfig {
  organizationId: string; // Fasyankes ID (e.g., "1000001")
  clientId: string;       // Satu Sehat Client ID
  secretKey: string;      // Satu Sehat Secret Key
  locations: KlinikLocationMap[];
}


export interface StructureNode {
  id: string;
  parentId: string | null;
  type: 'DIVISION' | 'GROUP';
  name: string;
  divisionId?: string;
  order?: number;
  children?: StructureNode[];
  members?: StructureMember[];
}

export interface StructureMember {
  id: string;
  employeeId: string;
  employeeName: string;
  positionId: string;
  positionName: string;
  divisionId?: string;
  divisionName?: string;
  nodeId?: string;
  isMainJob?: boolean;
  isPermitOfficer?: boolean;
}

export interface EkskulRecord {
  id: string;
  nama: string;
  pengajar: string;
  pengajarId?: string;
  jenjang: string[];
  hari: string[];
  jamMulai: string;
  jamSelesai: string;
  lokasi: string;
  peserta: { id: string; nama: string; kelas: string }[];
  status: 'Aktif' | 'Nonaktif';
  tahun_ajaran?: string;
  semester?: string;
}

export type NewEkskulData = Omit<EkskulRecord, 'id'>;

export interface NilaiEkskulRecord {
    id?: string;
    santri_id: string;
    nama_santri: string;
    ekskul_id: string;
    nama_ekskul: string;
    kelas_id: string;
    nama_kelas: string;
    tahun_ajaran: string;
    semester: string;
    penguasaan_materi: number | null;
    keaktifan: number | null;
    rata_rata_akhir: number | null;
    guru_id: string;
    nama_guru: string;
    created_at?: string;
    updated_at?: string;
}
